module.exports = __webpack_public_path__ + "assets/img/9_1008.847baa48.jpg";